import React from 'react';

function DashboardOverview() {
  return <h3 className="text-xl font-semibold">Dashboard Overview</h3>;
}

export default DashboardOverview;